




































































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsReaction from "@/design-system/components/ReactionPanel/JdsReaction.vue"
import JdsReactionOption from "@/design-system/components/ReactionPanel/JdsReactionOption.vue"

type options = 'hearts' | 'thumbs' | 'meh'

@Component({
    components: {JdsReactionOption, JdsReaction, JdiDocs, JdiPreview, JdiContent}
})
export default class ReactionPanel extends Vue {

    votes: Record<options, number> = {hearts: 2, thumbs: 1, meh: 0}
    myVotes: Array<string> = []

    handleClick(type: options) {
        if (this.myVotes.includes(type)) {
            this.$set(this.votes, type, this.votes[type] - 1)
            this.myVotes = this.myVotes.filter((el: string) => el !== type)
        } else {
            this.$set(this.votes, type, this.votes[type] + 1)
            this.myVotes.push(type)
        }
    }

}
